export default __webpack_public_path__ + "static/portrait5-7a0b6b26a25606bf73c1371e6fbff995.jpg";